import React from "react";
import Layout1 from "../../components/layout1";
import SubHeader from "../../components/subHeader";
import UpdateContent from "../update/content";

const Index = () => {
  return (
    <div>
      <Layout1>
        <SubHeader />
        <div className="contentclss">
          <div className="ordercls">Updates</div>
          <div className="sub2container mt-4">
            <UpdateContent />
          </div>
        </div>
      </Layout1>
    </div>
  );
};

export default Index;
